"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeFacetFilters = void 0;
const serializeStaticFilters_1 = require("./serializeStaticFilters");
function serializeFacetFilters(filters) {
    return JSON.stringify(filters
        .reduce(function (obj, filter) {
        const fieldId = filter.fieldId;
        obj[fieldId] = obj[fieldId] || [];
        obj[fieldId].push(serializeStaticFilters_1.shapeSimpleFilterForApi(filter));
        return obj;
    }, {}));
}
exports.serializeFacetFilters = serializeFacetFilters;
